define(['jquery',
        'datatables.net-buttons',
        'datatables.net-bs4',
        'datatables.net-buttons-bs4',
        'ouanalyse-datatables.net-buttons-html5',
        'datatables.net-responsive-bs4'],
    function($) {
        var datatables_default_options = {
            'deferRender': true,
            'autoWidth': false,
            'pageLength': 10,
            'lengthMenu': [[10, 25, 50, 100, -1], [10, 25, 50, 100, 'All']],
            'ajax': {
                'dataSrc': 'data'
            },
            'stateSave': true,
            'stateDuration': 60 * 60,
            'dom': 'lfrtip<"spacer">B',
            'buttons': [
                {
                    extend: 'csv',
                    text: '<span class="glyphicons glyphicons-arrow-down"></span>&nbsp;CSV',
                    exportOptions: {
                        orthogonal: 'exportTabular'
                    }
                }
                // {
                //     'extend': 'excel',
                //     'exportOptions': {
                //         'orthogonal': 'exportTabular'
                //     }
                // },
                // {
                //     'extend': 'pdf',
                //     'orientation': 'landscape',
                //     'pageSize': 'LEGAL',
                //     'exportOptions': {
                //         'orthogonal': 'exportPrint'
                //     }
                // },
                // {
                //     'extend': 'copy',
                //     'exportOptions': {
                //         'orthogonal': 'exportTabular'
                //     }
                // },
                // {
                //     'extend': 'print',
                //     'exportOptions': {
                //         'orthogonal': 'exportPrint'
                //     }
                // }
            ],
        };

        return {
            create: function(selector, options) {
                var combined_options = $.extend({}, datatables_default_options, options);

                // add focus to search bar consistent with other form inputs on the app
                $(selector).on('init.dt', function () { 
                    let wrapper = document.querySelector(`${selector}_wrapper`);
                    let searchInput = wrapper.querySelector('.dataTables_filter input');
                    if(!searchInput) return;

                    searchInput.addEventListener("focus", () => {
                        wrapper.querySelector(`${selector}_filter`).classList.add("search-focused");
                    })

                    searchInput.addEventListener("blur", () => {
                        wrapper.querySelector(`${selector}_filter`).classList.remove("search-focused");
                    })
                })

                return $(selector).DataTable(combined_options);
            },
            reloadData: function(selector, callback) {
                $(selector).DataTable().ajax.reload((data) => {
                    if(callback){
                        callback(data);
                    }                
                });                
            }
        };
    }
);
